import { GridColDef } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'

import { BaseTable } from 'Features/Projects/Table/BaseTable.view'

import { NetworkCapacitiesData } from './Capacities.types'

interface NetworkCapacitiesTableProps {
  data: NetworkCapacitiesData[]
  isLoading: boolean
}

export const NetworkCapacitiesTable = ({
  data,
  isLoading,
}: NetworkCapacitiesTableProps) => {
  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'destinationSiteCode',
        headerName: 'Destination Site Code',
        flex: 1,
        type: 'string',
        pinned: 'left',
      },
      {
        field: 'capacity',
        headerName: 'Capacity',
        flex: 1,
        type: 'number',
        editable: true,
        valueFormatter: (value) => {
          if (value === null || value === undefined) return ''
          return value
        },
      },
    ]
  }, [])

  return (
    <BaseTable
      data={data}
      columns={columns}
      isLoading={isLoading}
      updateTableData={() => {}}
      isUploading={false}
      isSaving={false}
      checkBoxSelection={true}
      pinnedColumns={['destinationSiteCode']}
    />
  )
}
